import { setupHidePrices } from './hide_prices'
import { initRecommendPopup } from './recommend_popup.js'

let current = 0

let index360 = 0
let interval = null

let current_interval = null
let current_index360 = 0
let HAS_360 = false

function main() {
   const container = document.querySelector('.images')
   const { index } = container.dataset
   current = Number(index)

   const curr = container.querySelector('.current')
   const current_image = curr.querySelector('.current__images')
   const slider_items = container.querySelectorAll(`.slider__item[data-type="image"]`)
   const item_360 = container.querySelector(`.slider__item[data-type="360"]`)
   const dots = container.querySelectorAll('.dot:not(.indicator-360)')
   const indicator360 = container.querySelector('.dot.indicator-360')

   if (indicator360)
      indicator360.addEventListener('click', (e) => {
         current = -1
         show360()
      })

   function changeDots() {
      if (indicator360) indicator360.className = 'dot indicator-360'
      dots.forEach((dot) => (dot.className = 'dot'))
      dots[current]?.classList.add('active')
   }
   function changeVisibility(item) {
      slider_items.forEach((item) => (item.className = 'slider__item'))
      if (item) item.classList.add('active')
   }
   function change() {
      if (current_interval) {
         clearInterval(current_interval)
         current_interval = null
         current_image.innerHTML = ''
         const _img = document.createElement('img')
         _img.loading = 'lazy'
         _img.className = 'active'
         current_image.appendChild(_img)
         item_360.classList.remove('active')
      }
      const item = slider_items[current]
      const img_item = item.querySelector('img')
      const img = current_image.querySelector('img')
      img.src = img_item.src
      changeDots()
      changeVisibility(item)
   }

   slider_items.forEach((item, i) => {
      item.addEventListener('click', (e) => {
         current = i
         change()
      })
   })

   dots.forEach((dot, i) => {
      dot.addEventListener('click', (e) => {
         current = i
         change()
      })
   })

   const next_btn = container.querySelector('.next__btn')
   const prev_btn = container.querySelector('.prev__btn')

   next_btn?.addEventListener('click', () => {
      current = current + 1
      changeDots()
      changeVisibility(null)
      if (current === slider_items.length && HAS_360) return show360()
      if (current >= slider_items.length) current = 0
      const dot = document.querySelector('.dot.indicator-360')
      if (dot) dot.classList.remove('active')
      change()
   })
   prev_btn?.addEventListener('click', () => {
      current = current - 1
      changeDots()
      changeVisibility(null)
      if (current === -1 && HAS_360) return show360()
      if (current < 0) current = slider_items.length - 1
      const dot = document.querySelector('.dot.indicator-360')
      if (dot) dot.classList.remove('active')
      change()
   })
}

let events_config = {
   autoplay: true,
   user_control: false,
   x: 0,
}

function show360() {
   if (current_interval) return null
   const _dots = document.querySelectorAll('.dot:not(.indicator-360)')
   _dots.forEach((d) => (d.className = 'dot'))

   const dot = document.querySelector('.dot.indicator-360')
   dot.classList.add('active')

   const thumbnails = document.querySelectorAll(`.slider__item[data-type="image"]`)
   thumbnails.forEach((thumb) => (thumb.className = 'slider__item'))

   const container = document.querySelector(`[data-type="360"]`)
   const aux = document.querySelector('.images')
   const img_container = aux.querySelector('.current__images')
   container.classList.add('active')

   if (container.childNodes) {
      const new_node = container.cloneNode(true)
      const newNodes = new_node.querySelectorAll('img')

      img_container.innerHTML = ''
      img_container.replaceChildren(...newNodes)

      const imgs = img_container.querySelectorAll('img')
      imgs.forEach((img) => {
         img.draggable = false
         img.className = ''
      })
      imgs[current_index360].classList.add('active')

      img_container.addEventListener('mouseenter', () => {
         events_config.autoplay = false
      })

      img_container.addEventListener('mouseleave', () => {
         events_config.autoplay = true
      })

      img_container.addEventListener('mousedown', (e) => {
         events_config.user_control = true
         events_config.x = e.clientX
      })

      img_container.addEventListener('mouseup', () => {
         events_config.user_control = false
      })

      img_container.addEventListener('mousemove', (e) => {
         if (!events_config.user_control) return null

         const delta = e.clientX - events_config.x
         if (Math.abs(delta) > 5) {
            if (delta > 0) current_index360 -= 1
            else current_index360 += 1
            console.log(current_index360)

            if (current_index360 <= 0) current_index360 = imgs.length - 1
            if (current_index360 > imgs.length - 1) current_index360 = 0

            imgs.forEach((img) => (img.className = ''))
            imgs[current_index360].classList.add('active')
         }
      })

      img_container.addEventListener('touchmove', (e) => {
         const delta = e.touches[0].clientX - events_config.x
         if (Math.abs(delta) > 5) {
            if (delta > 0) current_index360 -= 1
            else current_index360 += 1
            console.log(current_index360)

            if (current_index360 <= 0) current_index360 = imgs.length - 1
            if (current_index360 > imgs.length - 1) current_index360 = 0

            imgs.forEach((img) => (img.className = ''))
            imgs[current_index360].classList.add('active')
         }
      })

      current_interval = setInterval(() => {
         if (!events_config.autoplay) return null
         current_index360 += 1
         if (current_index360 >= imgs.length) current_index360 = 0
         imgs.forEach((img) => (img.className = ''))
         imgs[current_index360].classList.add('active')
      }, 150)
   }
}

function handle360Thumbnail() {
   const container = document.querySelector(`[data-type="360"]`)
   if (!container) return null
   const images = container.querySelectorAll('img')
   if (!interval) {
      interval = setInterval(() => {
         index360 += 1
         if (index360 >= images.length) index360 = 0

         images.forEach((img) => (img.className = ''))
         images[index360].className = 'active'
      }, 150)
   }

   container.addEventListener('click', () => {
      show360(container)
   })
}

window.addEventListener('DOMContentLoaded', (e) => {
   HAS_360 = document.querySelector(`[data-type="360"]`) || null
   main()
   handle360Thumbnail()
   setupHidePrices()
   handleSections()
   initRecommendPopup()
})

function handleSections() {
   const buttons = document.querySelectorAll('nav .btn')
}
